import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    class: "data-inconsistency-table",
    "data-cy": "data-inconsistency-table"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
import DataInconsistencyTableTooltip from './DataInconsistencyTableTooltip/DataInconsistencyTableTooltip.vue';
// libs
import { toRefs } from 'vue';
// utils
import { formatPercent } from '@/utilities/formatters';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataInconsistencyTable',
    props: {
        dataTable: {}
    },
    setup(__props) {
        const props = __props;
        // components
        const formatToPercent = (row, column, value) => {
            if (column?.property === 'percentErrors' || column?.property === 'treshold')
                return formatPercent(value / 100, 2);
            return value;
        };
        const { dataTable } = toRefs(props);
        return (_ctx, _cache) => {
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_el_table, {
                    data: _unref(dataTable).data,
                    stripe: "",
                    style: { "width": "100%" },
                    "scrollbar-always-on": true
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataTable).series, (column, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                (column.key === 'description')
                                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: 0,
                                        prop: column.key,
                                        label: column.name,
                                        width: "395"
                                    }, {
                                        default: _withCtx((scope) => [
                                            _createElementVNode("p", {
                                                innerHTML: scope.row.description
                                            }, null, 8, _hoisted_2)
                                        ]),
                                        _: 2
                                    }, 1032, ["prop", "label"]))
                                    : (column.key === 'examples')
                                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                                            key: 1,
                                            prop: column.key,
                                            label: column.name,
                                            width: "350"
                                        }, {
                                            default: _withCtx((scope) => [
                                                _createElementVNode("p", {
                                                    innerHTML: scope.row.examples
                                                }, null, 8, _hoisted_3)
                                            ]),
                                            _: 2
                                        }, 1032, ["prop", "label"]))
                                        : (column.key === 'treshold')
                                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                                key: 2,
                                                prop: column.key,
                                                label: column.name,
                                                width: "115",
                                                formatter: formatToPercent
                                            }, {
                                                header: _withCtx(() => [
                                                    _createVNode(DataInconsistencyTableTooltip, {
                                                        "label-name": column.name
                                                    }, null, 8, ["label-name"])
                                                ]),
                                                _: 2
                                            }, 1032, ["prop", "label"]))
                                            : (_openBlock(), _createBlock(_component_el_table_column, {
                                                key: 3,
                                                prop: column.key,
                                                label: column.name,
                                                width: "115",
                                                formatter: formatToPercent
                                            }, null, 8, ["prop", "label"]))
                            ], 64));
                        }), 128))
                    ]),
                    _: 1
                }, 8, ["data"])
            ]));
        };
    }
});
